module.exports = __webpack_public_path__ + "img/tg_02 (3).2e47b804.jpg";